




















































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import {
  ScriveTemplateSigningPartyFieldPlacementModel,
  ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel,
  Dictionary,
  Configuration
} from '@/types';
import { SignaturePageNumberLocationType } from '@/types/enums/SignaturePageNumberLocationType';
import ScriceUpdateSingingPartyFieldPlacement from '@/components/configuration/scrive/ScriveUpdateSingingPartyFieldPlacement.vue';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'ScriveAddSigningPartyFieldPlacement',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  data() {
    return {
      fieldPlacement: { pageNumberLocationType: 0 } as ScriveTemplateSigningPartyFieldPlacementModel,
      isLoading: true,
      isSubmitting: false,
      serverValidationMessage: ''
    };
  },
  methods: {
    async getSigningPartyFieldPlacementAsync(this: any) {
      this.isLoading = true;
      try {
        await ScriveConfigurationService.getTemplateSigningPartyFieldPlacementConfigurationAsync({
          templateSigningPartyFieldPlacementId: null
        });
      } catch {
        this.$log('Error getting field placement configuration');
      }
    },
    async onfieldPlacementSavedAsync(this: any) {
      this.resetFormValidation();

      const createModel = {
        templateSigningPartyFieldId: this.signingPartyFieldId,
        pageNumber: this.fieldPlacement.pageNumber,
        relativeXPosition: this.fieldPlacement.relativeXPosition,
        relativeYPosition: this.fieldPlacement.relativeYPosition,
        relativeHeight: this.fieldPlacement.relativeHeight,
        relativeWidth: this.fieldPlacement.relativeWidth,
        relativeFontSize: this.fieldPlacement.relativeFontSize,
        tip: this.fieldPlacement.tip,
        pageNumberLocationType: this.fieldPlacement.pageNumberLocationType
      } as ScriveTemplateSigningPartyFieldPlacementCreateUpdateModel;

      try {
        this.isSubmitting = true;
        const result = await ScriveConfigurationService.createSigningPartyFieldPlacementAsync(createModel);

        if (result.hasNotification && !result.showToast) {
          this.serverValidationMessage = result.notification;
          this.submitIsLoading = false;
          return;
        }

        SnotifyConfiguration.showSuccess('Field placement created successfully.');
        this.setApplicationDirty(false);

        this.navigateToEditSigningPartyField();
      } catch {
        this.$log('Error creating field placement');
      } finally {
        this.isSubmitting = false;
      }
    },
    navigateToEditSigningPartyField(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.signingPartyId = this.signingPartyId;
      param.id = this.signingPartyFieldId;
      this.$router.push({
        name: Configuration.Scrive.SigningPartyField.Edit.name,
        params: param
      });
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    signingPartyId(): number {
      return Number(this.$route.params.signingPartyId);
    },
    signingPartyFieldId(): number {
      return Number(this.$route.params.signingPartyFieldId);
    }
  },
  async mounted(this: any) {
    await this.getSigningPartyFieldPlacementAsync();
    this.fieldPlacement = this.DEFAULT_FIELD_PLACEMENT;
    this.isLoading = false;
  },
  created(this: any) {
    this.DEFAULT_FIELD_PLACEMENT = {
      pageNumber: 1,
      relativeXPosition: 0,
      relativeYPosition: 0,
      relativeWidth: 0,
      relativeHeight: 0,
      relativeFontSize: 0,
      tip: '',
      pageNumberLocationType: SignaturePageNumberLocationType.FromStart
    } as ScriveTemplateSigningPartyFieldPlacementModel;
  },
  components: {
    ScriceUpdateSingingPartyFieldPlacement,
    LoadingSpinner
  }
});
